import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { GenericLinkModule, IconModule, NavigationService } from '@spartacus/storefront';
import { CmsConfig, FeaturesConfigModule, I18nModule, provideConfig } from '@spartacus/core';
import { CustomNavigationComponent } from './navigation.component';
import { CustomNavigationUIComponent } from '../navigation-ui/navigation-ui.component';
import { CustomNavigationService } from './navigation.service';
import { MenuMobileComponent } from '../navigation-ui/menu-mobile/menu-mobile.component';
import { ScreenViewModule } from '../../../../../core/directives/screen-view/_screen-view.module';
import { MenuDesktopComponent } from '../navigation-ui/menu-desktop/menu-desktop.component';
import { BaseURLPipe } from '../../../../../core/pipes/base-url/base-url.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    IconModule,
    GenericLinkModule,
    I18nModule,
    FeaturesConfigModule,
    MenuMobileComponent,
    MenuDesktopComponent,
    ScreenViewModule,
  ],
  providers: [
    BaseURLPipe,
    provideConfig(<CmsConfig>{
      cmsComponents: {
        NavigationComponent: {
          component: CustomNavigationComponent,
        },
      },
    }),
    {
      provide: NavigationService,
      useClass: CustomNavigationService,
    },
  ],
  declarations: [CustomNavigationComponent, CustomNavigationUIComponent],
  exports: [CustomNavigationComponent, CustomNavigationUIComponent],
})
export class CustomNavigationModule {}
